
window.addEventListener('DOMContentLoaded', (event) => {
$(document).ready(function(){



  var counter=1;
  $('#index .logo_class').find('.page-width').each(function(){
    $(this).addClass('logo_class_'+counter);
    counter++;
  })
  

//=============start ta custom code main-banner section =================//
 var banner__reviews = $('.main-banner .banner-bix-main .banner__reviews');
 banner__reviews.on('click',function(){
    $('html, body').animate({
      scrollTop: $(".Reviews-list").offset().top
    }, 1000);
  })
//=============end ta custom code main-banner section =================//
//=============start ta custom code header section =================//
  
//   if(jQuery(window).width() >= 1200) {
//     if($('.header-wrapper .header').hasClass('Hush_mega-menu')){
     
//       if($('body').not('#index').length==1){
//         var header = $('#shopify-section-header');
//         $(window).scroll(function(){
//           var position = $('#MainContent').offset().top;;
//           var scroll = $(window).scrollTop();
//           if(scroll > position){
//             //header.addClass('not_for_indexalternate_sticky_header');
//           }else{
//             header.removeClass('not_for_indexalternate_sticky_header');
//           }

//         });
//       }else{
//       	var header = $('#shopify-section-header');
//         $(window).scroll(function(){
//           var position = $('#MainContent').offset().top;;
//           var scroll = $(window).scrollTop();
//           if(scroll > position){
//             header.removeClass('shopify-section-header-hidden');
            
//             //header.addClass('for_index_alternate_sticky_header');
//           }else{
//             header.removeClass('shopify-section-header-sticky');
//            // header.removeClass('for_index_alternate_sticky_header');
//             header.addClass('shopify-section-header-hidden');
//           }

//         });
//       }
      
      
    
//     }
//   }
//==============end ta custom code header section===================//


  // ===========Start ta code for customer review list section========//

  jQuery('.homeReviewSlidesWrap').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:"<img class="a-left control-c prev slick-prev" src="https://useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/76c55000867507091bdebafd4b09314d_leftgreyarrow.png">",
    nextArrow:"<img class="a-right control-c next slick-next" src="https://useruploads.visualwebsiteoptimizer.com/useruploads/176372/images/3221cf96cb3c8635f08cdef2297a7585_rightgreyarrow.png">",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $(document).on("click","a.continue_reading_custom",function() {
    $(".reviews_list").show();
    var revTitle        = $(this).parents(".reviewsSlidesInner").find('.revTitle').get(0).outerHTML;
    var revStars        = $(this).parents(".reviewsSlidesInner").find('.revStars').get(0).outerHTML;
    var revFullMsg      = $(this).parents(".reviewsSlidesInner").find('.revFullMsg').get(0).outerHTML;
    var revImageBox     = $(this).parents(".reviewsSlidesInner").find('.revImageBox').get(0).outerHTML;
    var revSlideNameLoc = $(this).parents(".reviewsSlidesInner").find('.revSlideNameLoc').get(0).outerHTML;
    var fullReviewsHtml = revTitle+revStars+revFullMsg+revImageBox+revSlideNameLoc
    $(".reviews_list.reviews__container").html(fullReviewsHtml);
  });

  $(".reviews_list_popup-inner-new .cross_icons").on("click",function(){
    $(".reviews_list").hide();
  });

  //=====================================end========================================//

  // ========================start ta custom for video popup========================//
  $("span.icon-play-homepage-video").on("click",function(){
    $('body').css('overflow','hidden')
    var getvideosrc = $(this).attr('src');
    //var getvideosrc = 'https://www.youtube.com/embed/vTTs2p_SVnw';
    if(getvideosrc.includes('vimeo') == true){
      $(".video-popup").show();
      $('.video_section .close').attr('data-type','vimeo');
      $("iframe#video_popup_player").attr('src',getvideosrc+'?autoplay=1');
      $("#video_popup_player_mp4").hide();
    }else if(getvideosrc.includes('mp4') == true){
      $(".video-popup").show();
      $("iframe#video_popup_player").hide();
      $("#video_popup_player_mp4 source").attr('src',getvideosrc);
    }else if(getvideosrc.includes('youtube') == true){
      $(".video-popup").show();
      $('.video_section .close').attr('data-type','youtube');
      $("iframe#video_popup_player").attr('src',getvideosrc);
      $("#video_popup_player_mp4").hide();
    }
  });

  $('.video_section .close').on("click",function(){
    $('body').css('overflow','unset');
    var data_type = $(this).attr('data-type');
    if(data_type == 'vimeo'){
      $(this).attr('data-type','');
      $(this).next('.popup_video_player_homepage').find('#video_popup_player').attr('src','');
      $(".video-popup").hide();
    }else if (data_type == 'youtube'){
      $(this).attr('data-type','');
      $(this).next('.popup_video_player_homepage').find('#video_popup_player').attr('src','');
      $(".video-popup").hide();
    }

  })
  
  $('.size_chart_container.video-popup').on('click',function(){
  $(this).css('display','none')
  $('body').css('overflow','unset');
   var close_btn = $(this).find('.pschart-sizechart-link-close');
   var data_type = $(this).find('.pschart-sizechart-link-close').attr('data-type');
   var video_popup_player = close_btn.next('.popup_video_player_homepage').find('#video_popup_player');
   if(data_type == 'vimeo'){
     video_popup_player.attr('src','');
     close_btn.attr('data-type','');
   }else if(data_type == 'youtube'){
     video_popup_player.attr('src','');
     close_btn.attr('data-type','');
   }
  });
  
  //=====================================end========================================//

  //=======================start ta custom for logo-bar section=====================//
  $(".logo_class .logo-bar li").on("click", function() {
    $(this).find(".popup-overlay, .popup-content").addClass("active");
     $('body').css('overflow','hidden')
  });
  $(document).on("click",'.logo_class .close, .logo_class .btn_cross', function() {
    $(".popup-overlay, .popup-content").removeClass("active");
     $('body').css('overflow','unset')
  });
  //=====================================end========================================//

  //=======================start ta custom for mega section=====================//
  $(".Hush_mega-menu ul.list-menu .header__menu-item").closest('details').on({ 
    mouseenter: function () {
      $(this).attr('open', true);
    },
    mouseleave: function () {
      $(this).attr('open', false);

    }

  })

  var intervall = setInterval(function(){ 
    var wgcurrent = $('.languge_switcher.descktop .wgcurrent').find('a').text();
    
    if(wgcurrent == 'FR'){
      $('.Desk_languge_switcher .languge_switcher').text('EN');
      $('.Mobile_language_switcher .languge_switcher').text('EN');
      clearInterval(intervall);
    }else if(wgcurrent == 'EN') {
      $('.Desk_languge_switcher .languge_switcher').text('FR');
      $('.Mobile_language_switcher .languge_switcher').text('FR');
      clearInterval(intervall);
    }
  },200);

  $(".Desk_languge_switcher span.languge_switcher").on("click",function(){
    var clicked = $(".languge_switcher.descktop .weglot-container").find("ul li").find("a").trigger("click");
  });
  $(".Mobile_language_switcher span.languge_switcher").on("click",function(){
    var clicked = $(".languge_switcher.descktop .weglot-container").find("ul li").find("a").trigger("click");
  });
  
  var pathname = window.location.pathname;
  if(pathname == '/pages/small-businesses'){
     $('.Desk_languge_switcher').css('display','none')
	 $('.Mobile_language_switcher').css('display','none')
  }else if( pathname == '/pages/privacy-policy'){
     $('.Desk_languge_switcher').css('display','none')
	 $('.Mobile_language_switcher').css('display','none')
  }else if(pathname == '/pages/5-reasons-why-canadians-love-this-weighted-blanket'){
     $('.Desk_languge_switcher').css('display','none')
	 $('.Mobile_language_switcher').css('display','none')
  }else if(pathname == '/blogs/sleep'){
     $('.Desk_languge_switcher').css('display','none')
	 $('.Mobile_language_switcher').css('display','none')
  }else if(pathname == '/pages/cooling-blanket-menopausal-hot-flash'){
     $('.Desk_languge_switcher').css('display','none')
	 $('.Mobile_language_switcher').css('display','none')
  }
  //=====================================end========================================//

  // ===========Start ta code for wieghted reviews section==========================//

  $('.weighted_blankets_slideshow .testimonial_slick_slider').slick({ 
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    autoplaySpeed: 3000,
    arrows : false,
    dots: true
  })


  //=====================================end========================================//

  // ==================Start ta code for Client List section=========================//
  $('.client_list_section .Client_slider').slick({ 
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 2000
        }
      }
    ]
  })
// ===============================Alternate_product.liquid template==================//
 //============Start for sticky pdp button============//
 window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(timeOutFn){return setTimeout(timeOutFn, 1000 / 60);};
 window['alternate_product_sticky_button'] = function(){
   if (window.matchMedia("(max-width: 600px)").matches)  {
     var alternate_pdp_sticky_var = setInterval(alternate_pad_sticky_fun, 3000);
     var pdp_length='';
     function alternate_pad_sticky_fun(){
       pdp_length = $('#alternate_product').length;
       if(pdp_length == 1){
          clearInterval(alternate_pdp_sticky_var);
          alternate_pdp_sticky_main_fun();
       }
     }
     function alternate_pdp_sticky_main_fun(){
       
        if(typeof jQuery == 'function' && jQuery('body').length && !document.getElementsByClassName('template_product').length){
          document.body.classList.add('template_product');
          document.body.classList.add('alternate_pdp_sticky');
          
          jQuery.fn.itemIsInViewport = function(options) {
            var defaultOptions = {
              topSpacing: 0,
              bottomSpacing: 0
            };
            var opts = jQuery.extend( {}, defaultOptions, options );
            if(!jQuery(this).length) return;
            var scrollTop = jQuery(window).scrollTop(),
                winHeight = jQuery(window).height(),
                item = jQuery(this);
            return scrollTop > (item.offset().top - winHeight + opts.bottomSpacing) && scrollTop < (item.offset().top + item.innerHeight() - opts.topSpacing);
          };

          var old_btntextreplace_thirdAvailability = thirdAvailability;
          thirdAvailability = function(){
             old_btntextreplace_thirdAvailability();
            setTimeout(function(){ checkSelectedOptions(); }, 550);
          }
          var old_btntextreplace_secondAvailability = secondAvailability;
          secondAvailability = function(){
            old_btntextreplace_secondAvailability();
            setTimeout(function(){ checkSelectedOptions(); }, 550);
          }
         var old_btntextreplace_oneAvailability = oneAvailability;
          oneAvailability = function(){
            old_btntextreplace_oneAvailability()
            setTimeout(function(){ checkSelectedOptions(); }, 550);
          }
          var html = '';
          html += '<div class="stickyAddCartOverlay" style="display:none;">';
          html += '<div class="stickyAddCartInnerWrap">';
          html += '<div class="stickyAddCartBottomFix">';
          html += '<div class="stickyAddCartBottomBack"></div>';
          html += '<div class="stickyStepPriceWrap"> <div class="stickyProgressbar"></div> <div class="stickyPricingBlock"></div></div>';
          html += '<div class="stickyAddCartStepsWrapOverflow"><div class="stickyAddCartStepsWrap"></div></div>';
          html += '</div>';
          html += '<div class="stickyAddCartEachOptionsWrap"></div>';
          html += '</div>';
          html += '</div>';
          jQuery('body.alternate_pdp_sticky').prepend(html);
          jQuery('.alternate_pdp_sticky .swatch').each(function(i){
            var thisOpt = jQuery(this),
                selectionVal = '',
                swatchHeader = jQuery(this).find('.header').clone(),
                spanClass = '';
            
                selectionVal = 'Select ' + swatchHeader.text().trim();
                jQuery('.stickyAddCartStepsWrap').append('<div class="stickyAddCartEachBox" data-step="'+(i+1)+'"><div class="optSeclectTrigger" data-val="'+selectionVal+'">'+selectionVal+'</div><a href="javascript:void(0)" class="optSeclectNext">Next</a></div>');
                if(i==0){
                  spanClass = 'stepSpanActive';
                }
                jQuery('.stickyProgressbar').append('<span class="'+spanClass+'" data-step="'+(i+1)+'"></span>');
                var html = '<div class="stickyAddCartOptionsPopup" data-options-for="'+selectionVal+'"><div class="stickyAddCartOptionsHeader"><span>'+selectionVal+'</span><div class="newCampPopClose"></div></div><div class="stickyAddCartOptionsEach"><ul>';
                jQuery(this).find('.swatch-element').each(function(){
                  var thisRadio = jQuery(this).find('input[type="radio"]'),
                      inputID = thisRadio.attr('id'),
                      thisLabel = jQuery('label[for="'+inputID+'"]');
                  html += '<li data-id="'+inputID+'">';
                  if(jQuery(this).hasClass('color')){
                    var bgImg = thisLabel.css('backgroundImage').replace(/^url\(['"](.+)['"]\)/, '$1'),
                        bgValue = 'background-image: url(' + bgImg + ')';

                    if(bgImg == 'none'){
                      bgValue = 'background-color: ' + thisLabel.css('backgroundColor') + ';';
                    }
                    html += '<div class="stickyLabelImg" style="'+bgValue+'"></div><span>'+thisRadio.attr('value')+'</span>';
                  }else{
                    html += '<span>' + thisLabel.text().trim() + '</span>';
                  }
                  html += '</li>';
                });
                html += '</ul></div></div>';
               jQuery('.stickyAddCartEachOptionsWrap').append(html);
          });
          
          if(jQuery('.stickyProgressbar span').length){
            jQuery('.stickyProgressbar').append('<span data-step="'+(jQuery('.alternate_pdp_sticky .swatch').length + 1)+'"></span>');
          }
          else{
            jQuery('.stickyAddCartBottomFix').addClass('stickyAddCartBottomFixNoVariants');
          }
          
          jQuery('.stickyAddCartStepsWrap').append('<div class="stickyAddCartEachBox stickyAddCartEachSubmit" data-step="'+(jQuery('.alternate_pdp_sticky .swatch').length + 1)+'"><a href="javascript:void(0)" class="stickyAddCartBtn">Ajouter au panier</a></div>');
          jQuery('.stickyAddCartStepsWrap').css('width', jQuery('.stickyAddCartStepsWrap .stickyAddCartEachBox').length * 100 + '%').find('.stickyAddCartEachBox').css('width', 100 / jQuery('.stickyAddCartStepsWrap .stickyAddCartEachBox').length + '%');
          
          window['slideStickyStep2534'] = function(value){
            jQuery('.stickyAddCartStepsWrap').css('left', '-' + (value) * 100 + '%');

            jQuery('.stickyAddCartOptionsPopupActive').find('.newCampPopClose').click();

            if(value > 0){
              jQuery('.stickyAddCartBottomBack').addClass('stickyBackActive');
            }else{
              jQuery('.stickyAddCartBottomBack').removeClass('stickyBackActive');
            }
            jQuery('.stickyProgressbar span').each(function(i){
              if((i+1) > (value+1)){
                jQuery(this).removeClass('stepSpanActive');
              }else{
                jQuery(this).addClass('stepSpanActive');
              }
            });
          };
          
          jQuery(document).on('click', '.stickyProgressbar span', function(){
            if(jQuery(this).hasClass('stepSpanActive')){
              var thisStepVal = parseInt(jQuery(this).attr('data-step')) - 1;
              slideStickyStep2534(thisStepVal);
            }
          });
    	     
          jQuery(document).on('click', '.stickyAddCartBottomBack', function(){
            var currentLeft = Math.abs(parseFloat(jQuery('.stickyAddCartStepsWrap')[0].style.left)) / 100;
            if(currentLeft > 0){
              currentLeft = currentLeft - 1;
              slideStickyStep2534(currentLeft);
            }
          }); 
          
          jQuery(document).on('click', '.optSeclectNext', function(){
            var thisStepVal = parseInt(jQuery(this).parents('.stickyAddCartEachBox').attr('data-step'));
            slideStickyStep2534(thisStepVal);
          });
          
          jQuery(document).on('click', '.optSeclectTrigger', function(){
            var thidVal = jQuery(this).attr('data-val');
            jQuery('body').addClass('stickyAddCartOverlayOptActive');
            jQuery('.stickyAddCartOptionsPopup').removeClass('stickyAddCartOptionsPopupActive');
            jQuery('.stickyAddCartOptionsPopup[data-options-for="'+thidVal+'"]').addClass('stickyAddCartOptionsPopupActive');
          });
          
          jQuery(document).on('click', '.stickyAddCartOptionsPopup .newCampPopClose', function(){
            jQuery('body').removeClass('stickyAddCartOverlayOptActive');
            jQuery('.stickyAddCartOptionsPopup').removeClass('stickyAddCartOptionsPopupActive');
          });
          
          jQuery(document).on('click', '.stickyAddCartOptionsEach ul li', function(){
           
            if(jQuery(this).hasClass('liOptDisabled')) return;
            var thisLi = jQuery(this),
                inputID = thisLi.attr('data-id'); 
            jQuery(this).parent().find('.liOptionSelected').removeClass('liOptionSelected');
            jQuery(this).addClass('liOptionSelected');
            thisLi.parents('.stickyAddCartOptionsPopup').find('.newCampPopClose').click();
            jQuery('.alternate_pdp_sticky input#' + inputID)[0].click();;
            checkSelectedOptions();
          });
          
          jQuery(document).on('click', '.stickyAddCartEachSubmit .stickyAddCartBtn', function(){
            jQuery('.hush_product_button .product-form__submit').click();
          });
         
          function checkSelectedOptions(){
            
            jQuery('.stickyAddCartOptionsEach ul li').removeClass('liOptDisabled liOptHidden liOptionSelected');
            jQuery('.alternate_pdp_sticky .swatch').each(function(i){
              var hasCheckboxChecked = false;
              jQuery(this).find('.swatch-element').each(function(){
                var thisRadio = jQuery(this).find('input[type="radio"]'),
                    inputID = thisRadio.attr('id');
                
                if(jQuery(this).hasClass('Unavailable_2') || jQuery(this).hasClass('Unavailable_1')){
                 //alert(inputID)
                  jQuery('.stickyAddCartOptionsEach ul li[data-id="'+inputID+'"]').addClass('liOptDisabled');
                }
                if(jQuery(this).css('display') == 'none'){
                  jQuery('.stickyAddCartOptionsEach ul li[data-id="'+inputID+'"]').addClass('liOptHidden');
                }
                if(thisRadio.is(':checked') ){
                  jQuery('.stickyAddCartOptionsEach ul li[data-id="'+inputID+'"]').addClass('liOptionSelected');
                }
              });
              if(!jQuery(this).find('input[type="radio"]:checked').length) {
                var firstAvailableInputID = jQuery(this).find('.swatch-element.available_1, .swatch-element.available_2').find('input[type="radio"]').attr('id');
                jQuery('.stickyAddCartOptionsEach ul li[data-id="'+firstAvailableInputID+'"]').addClass('liOptionSelected');
              }
            });
            jQuery('.optSeclectTrigger').each(function(){
              var thisVal = jQuery(this).attr('data-val'),
                  selectedLabel = jQuery('.stickyAddCartOptionsPopup[data-options-for="'+thisVal+'"]').find('.liOptionSelected span').text();
        
              jQuery(this).text(selectedLabel);
            });
            
            if(jQuery('.price_main .price.price--large').hasClass('price--on-sale')){
              jQuery('.stickyPricingBlock').text( jQuery('.price_main .price.price--large.price--on-sale .price__sale span.price-item.price-item--sale').text().trim() );
            }else{
            
            jQuery('.stickyPricingBlock').text( jQuery('.price_main .price__regular span.price-item').text().trim() );
            }
            
            jQuery('.stickyAddCartEachSubmit .stickyAddCartBtn').text( jQuery('.hush_product_button .product-form__submit').text().trim() );
            if(jQuery('.hush_product_button .product-form__submit').hasClass('pre_order_btn')){
              jQuery('.stickyAddCartEachSubmit .stickyAddCartBtn').addClass('stickyAddCartBtnPreOrder');
            }else{
              jQuery('.stickyAddCartEachSubmit .stickyAddCartBtn').removeClass('stickyAddCartBtnPreOrder');
            }
          }
          checkSelectedOptions();
          
          jQuery(window).scroll(function(){
            if(jQuery('.hush_product_button').itemIsInViewport()){
              jQuery('body').addClass('hideCustomAddCartPopup');
            }else{
              jQuery('body').removeClass('hideCustomAddCartPopup');
            }
          });
          
          
        }else if(!document.getElementsByClassName('template_product').length){
            window.requestAnimationFrame(alternate_product_sticky_button);
        }
         
     } // ending alternate_pdp_sticky_main_fun

   }
  }
 window.alternate_product_sticky_button(); 
 //============End for sticky pdp button============//

  
if(window.matchMedia("(min-width: 700px)").matches)  {  
window['alternate_pdp_zoom_feature']=function(){
    var slides_length ='';
    var alternate_pdpvar = setInterval(alternate_pad_fun, 3000);
    function alternate_pad_fun(){
      slides_length = $('#alternate_product .main_product_slider .slick-slide img[srcset*="cdn.shopify"]').length;
      if(slides_length>1){
        clearInterval(alternate_pdpvar);
        add_alternate_pdp_class();
      }
    }
    function add_alternate_pdp_class(){
      if(slides_length > 1 && !document.getElementsByClassName('alternate_pdp_zoom_feature').length){
        $('body').addClass('alternate_pdp_zoom_feature');
//         $('body').addClass('alternate_pdp_quiz_feature');
        function zoomImages(e){
          var zoomer = e.currentTarget;
          e.offsetX = e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
          e.offsetY = e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
          var x = offsetX / zoomer.offsetWidth * 100;
          var y = offsetY / zoomer.offsetHeight * 100;
          zoomer.style.backgroundPosition = x + '% ' + y + '%';
        }
        
        var main_product_current_slider ='.alternate_pdp_zoom_feature .main_product_slider .slick-slide .product__media';
        $(document).on('mousemove',main_product_current_slider ,function(e){
          var current_slide = $(this).closest('.main_product_slider').find('.slick-current');
          var current_data_slick_index= $(this).closest('.main_product_slider').find('.slick-current').attr('data-slick-index');
          var srcset_length = $(this).closest('.main_product_slider').find('.slick-current').find('img').attr('srcset').split(',').length;
          var last_srcset_index = srcset_length - 1;
          var all_srcset= $(this).closest('.main_product_slider').find('.slick-current').find('img').attr('srcset').split(',');
          var current_scrset = all_srcset[last_srcset_index - 1].trim();
          var current_active_slide_img = current_scrset.split(' ')[0];
          /*
          if(!current_slide.find('.product__media').hasClass('vwo-hovered')) {
            current_slide.find('.product__media').css({"background-image": "url("+current_active_slide_img+")"}).addClass('vwo-hovered');
          }
          */
           zoomImages(e);
        });
        main_product_current_slider.mouseleave(function(){
        $('.main_product_slider').find('.product__media').css("background-image", "");
        /*$('.main_product_slider').find('.product__media').removeClass("vwo-hovered");*/
        });
        
      }
    }
    
//=========for adding quiz==============//


    
  }
window.alternate_pdp_zoom_feature();
 }
  
  var sizesArray = [
     {size:'TWIN 60x80', weights:['80-150', '151-299', '300-309', '310-349', '350+']},
     {size:'QUEEN 80x87', weights:['80-200', '201-250', '251+']},
     {size:'KING 90x90', weights:['80-300', '301-350', '351+']}
   ];
   var weightsArray = [
     {size:'TWIN 60x80', weight:'15lb', bodyWeights:[8,9,10,11,12,13,14,15]},
     {size:'TWIN 60x80', weight:'20lb', bodyWeights:[16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40]},
     {size:'QUEEN 80x87', weight:'20lb', bodyWeights:[8,9,10,11,12,13,14,15,16,17,18,19,20]},
     {size:'QUEEN 80x87', weight:'25lb', bodyWeights:[21,22,23,24,25]},
     {size:'QUEEN 80x87', weight:'30lb', bodyWeights:[26,27,28,29,30,31,32,33,34,35,36,37,38,39,40]},
     {size:'KING 90x90', weight:'30lb', bodyWeights:[8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]},
     {size:'KING 90x90', weight:'35lb', bodyWeights:[31,32,33,34,35,36,37,38,39,40]}
   ]; 
 window['alternate_pdp_quiz_feature']=function(){ 

    var alternate_pdp_quiz_var = setInterval(alternate_pad_quiz_fun, 3000);
    var product_handle = '';
    function alternate_pad_quiz_fun(){
     var pdp_length = $('#alternate_product').length;
      product_handle = $('.quiz_product').attr('id');
      if(pdp_length == 1 && typeof product_handle !== "undefined" && product_handle != 'hush-sheets'){
        clearInterval(alternate_pdp_quiz_var);
        add_alternate_pdp_quiz_class();
      }
    }
   function add_alternate_pdp_quiz_class(){
     $('body').addClass('alternate_pdp_quiz_feature');
     $('.alternate_pdp_quiz_feature #alternate_product .swatch .header').each(function(){
       var case_text = $(this).text().toLowerCase();
       var get_option = case_text.split(' ')[0]
       if(case_text.includes('size') || case_text.includes('weight')){
         $(this).closest('.swatch').addClass(get_option+'_option');
       }
     })
	 addTakeAQuizLink();
     addQuizPopup();
     checkActiveQues();
     addWeightChange();
     changeAddToCartBtnTxt();
     onFetchEnd_2809();
   }
}
  
 function addTakeAQuizLink(){
   /*
   var toolTipHtml = '<span class="vwo_qLink">(Répondez à un quiz)</span>';
   if(!$('.vwo_qLink').length){
     $('.swatch.size_option > .header').append(toolTipHtml);
   }
   */
 }
  function addQuizPopup(){
    /*
    var qHtml = '<div class="vwo_modal"><span class="vwo_overlay"></span><div class="modalContent">';
    qHtml += '<span class="popClose">×</span>';
    qHtml += '<div class="quesStepper" data-current-ques="1">';
    qHtml += '<div class="qBlock qBedSize" data-ques="1"><h3>Quelle est la taille de votre lit ?</h3><div class="qAns aBedSize"></div></div>';
    qHtml += '<div class="qBlock qWeight" data-ques="2"><h3>Quels sont vos poids combinés (ou votre poids si vous dormez seul) ?</h3><div class="qAns aWeight"></div></div>';
    qHtml += '<div class="qBlock qResult" data-ques="3"><div class="qAns aResult"></div><div class="resText">You will get your best sleep with this Hush Blanket.</div><div class="btnsArea"><button onclick="gotoQues(1)" class="recalcBtn btn btn--fill btn--color btn--regular"><span class="v_lArrow">←</span>Go Back</button><button onclick="triggerCartClick()" class="v_cartBtn btn btn--fill btn--color btn--regular"><span class="v_btnTxt">Ajouter à la liste Panier</span> <svg class="cartLoader" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"> <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></button></div></div>';
    qHtml += '</div>';
    qHtml += '</div></div>';
    if(!$('.vwo_quizPopup').length){
      $('body').prepend(qHtml);
      addBedSizes();
      addSizeClick();
    }
    */
  }
  function addBedSizes(){
    $('.size_option .swatch-element').each(function(){
      var text = $(this).find('input[type=radio]').val().trim();
      var aHtml = '';
      if(!$(this).hasClass('not-avilable')){
        aHtml = '<a href="javascript:void(0);">'+text+'</a>';
      } else {
        aHtml = '<a href="javascript:void(0);" class="disabled" disabled="">'+text+'</a>';
      }
      $(aHtml).appendTo('.aBedSize');
    });
  }
  function addSizeClick(){
    $(document).on('click', '.aBedSize a', function(){
      var prodName = formatProdName($('.product__title').text().trim());
      $('.aBedSize a').removeClass('active');
      $(this).addClass('active');
      var size = $(this).text();
      
      var selectedWeight = '';
      if(size.indexOf('TEEN') > -1){
        $('.qResult').attr('data-size', size).attr('data-weight', '12lb');
        gotoQues(3);
        $('.aResult').html('<p>YOU + a <strong>12lb</strong> '+prodName+' are a match made in heaven!</p>');
        selectedWeight = '12lb';
      } else if(size.indexOf('KID') > -1){
        $('.qResult').attr('data-size', size).attr('data-weight', '5lb');
        gotoQues(3);
        $('.aResult').html('<p>YOU + a <strong>5lb</strong> '+prodName+' are a match made in heaven!</p>');
        selectedWeight = '5lb';
      } else {
        $('.qWeight').attr('data-size', size);
        gotoQues(2);
        generateWeights(size);
      }
      triggerSizeSelection(size);
      setTimeout(function(){
        if(selectedWeight){
          triggerWeightSelection(selectedWeight);
        }
      },1000);
    });
  }
  function generateWeights(size){
    var sel = '<div class="selectedSize"><p>Selected Size: '+size+' <a href="javascript:void(0);" onclick="gotoQues(1)" class="change_size">Change here</a></p><select class="sizeOpts"><option value="null">Sélectionner le poids</option>';
    for(var i=0; i<sizesarray.length; i++){="" var="" sizeThis="sizesArray[i].size;" if(sizeThis="=" size){="" weights="sizesArray[i].weights;" for(var="" j="0;" j<="" weights.length;="" j++){="" weight="weights[j];" sel="" +="weight.indexOf('-')"> -1 ? '<option value="'+weight+'">'+weight+' LB</option>' : '<option value="'+weight+'">'+weight.replace('+', '')+'LB+</option>';
        }
      }
    }
    sel += '</sizesarray.length;></select></div>';
    $('.aWeight').html(sel);
  }
  function addWeightChange(){
    $(document).on('change', '.sizeOpts', function(){
      var prodName = formatProdName($('.product__title').text().trim());
      var minweight = $(this).val().indexOf('-') > -1 ? parseInt($(this).val().split('-').shift()) : parseInt($(this).val().split('+').shift());
      var maxWeight = $(this).val().indexOf('-') > -1 ? parseInt($(this).val().split('-').pop()) : 400;
      var finalMinWeight = (10/100)*minweight;
      var finalMaxWeight = (10/100)*maxWeight;
      var selectedSize = $('.qWeight').attr('data-size');
      for(var i=0; i<weightsarray.length; i++){="" var="" sizeArr="weightsArray[i].size;" if(selectedSize="=" sizeArr){="" bodyWeights="weightsArray[i].bodyWeights;" selectedWeight="" ;="" for(var="" j="0;" j<bodyWeights.length;="" j++){="" if(bodyWeights[i]="" <="finalMaxWeight){" $('.qResult').attr('data-size',="" selectedSize).attr('data-weight',="" weightsArray[i].weight);="" gotoQues(3);="" $('.aResult').html('<p="">YOU + a <strong>'+weightsArray[i].weight+'</strong> '+prodName+' are a match made in heaven!<p></p>');
              selectedWeight = weightsArray[i].weight;
            }
          }
          if(selectedWeight){
            triggerWeightSelection(selectedWeight);
          }
        }
      }
    });
  }
  function triggerVariants(cb){
    var size = $('.qResult').attr('data-size');
    var weight = $('.qResult').attr('data-weight');
    $('.size_option .swatch-element:not(.not-avilable) label:contains('+size+')').click();
    setTimeout(function(){
      var availableWeight = $('.weight_option .swatch-element:not(.not-avilable):visible label:contains('+weight.toUpperCase()+')').length ? $('.weight_option .swatch-element:not(.not-avilable):visible label:contains('+weight.toUpperCase()+')') : $('.weight_option .swatch-element:not(.not-avilable):visible label:contains('+weight+')');
      if(availableWeight.length){
        availableWeight.click();
        closeQPop();
        cb();
      } else {
        $('body').removeClass('loadingPop');
        alert('Blanket weight not available for selection for now.');
      }
    },1000);
  }
  function triggerSizeSelection(size){
    //$('.size_option .swatch-element:not(.not-avilable) label:contains('+size+')').trigger("click");
    $('.size_option .swatch-element:visible label:contains('+size+')').prev('input')[0].click();
  }
  function triggerWeightSelection(weight){
    //var availableWeight = $('.weight_option .swatch-element:not(.not-avilable):visible label:contains('+weight.toUpperCase()+')').length ? $('.weight_option .swatch-element:not(.not-avilable):visible label:contains('+weight.toUpperCase()+')') : $('.weight_option .swatch-element:not(.not-avilable):visible label:contains('+weight+')');
    var availableWeight = $('.weight_option .swatch-element:visible label:contains('+weight.toUpperCase()+')').length ? $('.weight_option .swatch-element:visible label:contains('+weight.toUpperCase()+')') : $('.weight_option .swatch-element:visible label:contains('+weight+')');
    if(availableWeight.length){
      availableWeight[0].click();
      changeAddToCartBtnTxt();
    } 
    /*else {
    alert('Blanket weight not available for selection for now.');
  }*/
  }
  function gotoQues(ques){
    
    $('.quesStepper').attr('data-current-ques', ques);
    checkActiveQues();
  }
  function openQPop(){
    if($('.quesStepper').attr('data-current-ques') == '3'){
      resetQuiz();
    }
    $('body').addClass('popupOpened');
    $('.aBedSize').html('');
    addBedSizes();
  }
  function resetQuiz(){
    $('.quesStepper').attr('data-current-ques', '1');
    $('.qResult').removeAttr('data-weight').removeAttr('data-size');
    $('.qWeight').removeAttr('data-size');
    checkActiveQues();
  }
  function closeQPop(){
    $('body').addClass('closingPop');
    setTimeout(function(){
      $('body').removeClass('closingPop popupOpened');
    },350);
  }
  function checkActiveQues(){
    var currStep = $('.quesStepper').attr('data-current-ques');
    $('.qBlock').hide();
    $('.qBlock[data-ques='+currStep+']').fadeIn();
  }
  function triggerCartClick(){
    $('body').addClass('loadingPop');
    triggerVariants(function(){
      setTimeout(function(){
        var findBtnVisible = setInterval(function(){
          if($('.hush_product_button .product-form__submit:visible').length){
            $('.hush_product_button .product-form__submit:visible').click();
            $('body').removeClass('loadingPop');
            clearInterval(findBtnVisible);
          }
        },100);
      },500);
    });
  }
  function changeAddToCartBtnTxt(){
    setTimeout(function(){
      var currBtnTxt = $('.hush_product_button .product-form__submit:visible').text().trim();
      var currbtnBg = $('.hush_product_button .product-form__submit:visible').css('background-color');
      $('.v_cartBtn').css('background-color', currbtnBg);
      $('.v_btnTxt').text(currBtnTxt);
    },500);
  }
  function formatProdName(prodName){
    if(prodName.indexOf('Hush Classic') > -1){
      prodName = "Hush Classic Blanket";
    } else if(prodName.indexOf('Hush Iced') > -1){
      prodName = "Hush Iced Blanket";
    } else if(prodName.indexOf('2-in-1') > -1){
      prodName = "Hush 2-in-1 Blanket";
    } else if(prodName.indexOf('Hush Kids') > -1){
      prodName = "Hush Kids Blanket";
    }
    return prodName;
  }
  function onFetchEnd_2809(){
    var _oldFetch = fetch;
    window.fetch = function(){
      var fetchStart = new Event( 'fetchStart', { 'view': document, 'bubbles': true, 'cancelable': false } );
      var fetchEnd = new Event( 'fetchEnd', { 'view': document, 'bubbles': true, 'cancelable': false } );
      var fetchCall = _oldFetch.apply(this, arguments);
      document.dispatchEvent(fetchStart);
      fetchCall.then(function(){
        document.dispatchEvent(fetchEnd);
      }).catch(function(){
        document.dispatchEvent(fetchEnd);
      });
      return fetchCall;
    };
    document.addEventListener('fetchEnd', function() {
      changeAddToCartBtnTxt();
    });
  }

  function formatProdName(prodName){
    if(prodName.indexOf('Hush Classic') > -1){
      prodName = "Hush Classic Blanket";
    } else if(prodName.indexOf('Hush Iced') > -1){
      prodName = "Hush Iced Blanket";
    } else if(prodName.indexOf('2-in-1') > -1){
      prodName = "Hush 2-in-1 Blanket";
    } else if(prodName.indexOf('Hush Kids') > -1){
      prodName = "Hush Kids Blanket";
    }
    return prodName;
  }
  
  window.alternate_pdp_quiz_feature();
  
  /*$(document).on('click', '.size_option .vwo_qLink', function () {
    openQPop()
  }); */
  $(document).on('click', '.popClose', function () {
    closeQPop()
  });
  $(document).on('click', '.recalcBtn', function (e) {
    gotoQues(1)
  });
  $(document).on('click', '.change_size', function (e) {
    gotoQues(1)
  });
  $(document).on('click', '.v_cartBtn', function (e) {
    triggerCartClick()
  });
  // ============ending===================//
// ===========================ENDING=====================================//
  var myVar = setInterval(reviews_trgger, 3000);
  function reviews_trgger(){
    var alternate_stamp_badge_div = $('#alternate_product .product__info-container span.stamped-badge');
    var alternate_prodReviews_div = $("#alternate_product .customjtpl_accordion.prodReviews");
    if(alternate_stamp_badge_div.length >0){
      clearInterval(myVar);
      alternate_stamp_badge_div.click(function(){
        $('html, body').animate({
          scrollTop: $(".customjtpl_accordion.prodReviews").offset().top
        }, 1000);
        if(!alternate_prodReviews_div.hasClass('active')){
          alternate_prodReviews_div.children('h4').trigger('click');
        }
        
      });
    }
  }
  
  $('#alternate_product .product__media-list').slick({
    infinite: false,
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 4,
    slidesToScroll: 3,
    prevArrow:'<i class="fas fa-chevron-up" aria-hidden="true"></i>',
    nextArrow:'<i class="fas fa-chevron-down" aria-hidden="true"></i>',
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
          prevArrow:'<i class="fas fa-chevron-up" aria-hidden="true"></i>',
          nextArrow:'<i class="fas fa-chevron-down" aria-hidden="true"></i>'
        }
      }
    ]
  });
  
  
  $('#alternate_product .main_product_slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    prevArrow: false,
    nextArrow: false
  });
 
  
  $('#alternate_product .customjtpl_accordion > h4').click(function(){
    var THIS = $(this);
    $(this).next('.customjtpl_body').slideToggle();
    $(this).parent().toggleClass('active');
    $('#alternate_product .customjtpl_accordion .customjtpl_body').not($(this).next('.customjtpl_body')).hide();
    $('#alternate_product .customjtpl_accordion').not($(this).parent()).removeClass('active');
    if($(this).parent().hasClass('active')){
      $('html,body').animate({
        scrollTop:THIS.offset().top - 74
      },500);
    }
  });
 
  var sezzle_myVar = setInterval(sezzle_popup_trgger, 3000);
  function sezzle_popup_trgger(){
    var sezzle_btn = $('#alternate_product .sezzle-shopify-info-button');
    var sezzle_popup_box=$('body').next('.sezzle-checkout-modal-lightbox');
    if(sezzle_popup_box.length>0){
      clearInterval(sezzle_myVar);
      sezzle_btn.click(function(){
        sezzle_popup_box.css('display','block')
      });
    }

  }
 
	
	$('ul.tabs li').click(function(){
     
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})



  //=====================================end========================================//
    
function hush_custom_reviews_ratings(){
  if(window.matchMedia("(max-width: 767px)").matches){
   var reviews_var =  setInterval(get_reviews_length, 2000);
    function get_reviews_length(){
      if($('#alternate_product').length && !$('.hush_custom_ratings').length && $('.stamped-main-badge').length){
          $('.stamped-main-badge').addClass('hush_custom_ratings');
          var data_rating = $('.stamped-badge').attr('data-rating')
          clearInterval(reviews_var);
		  $('#alternate_product .stamped-badge').prepend('<strong>'+data_rating+'</strong>')
          $('#alternate_product .stamped-badge-caption').prepend('Based on ')
      }
    }
  }else{
    //$('#alternate_product .stamped-main-badge').css('display','none')
  }
}
hush_custom_reviews_ratings();  

//====================START ADJUSTING THE SPECIFIC PAGE HEIGHT=======================//

//===================ENDING ADJUSTING THE SPECIFIC PAGE HEIGHT========================//
    
    var windowwidth = $(window).width();
    if($('.main-banner').find('.banner--adapt').hasClass('.specific_hush_banner_content_class')){
      if(windowwidth > 1200 ){
        var header =  jQuery('.header-main').height();
        jQuery( '.banner__content' ).css( 'padding-top',header);
        jQuery( '.banner__content' ).css( 'opacity',1);
      }
      if(windowwidth < 1200 ){
        jQuery( '.banner__content' ).css( 'opacity',1);
      }
    }
})

// ========================iframe responsive=====================================//
function adjustIframes()
{
  $('.All_PageHandle_our-giveback-blanket-donation-program iframe').each(function(){
    var
    $this       = $(this),
    proportion  = $this.data( 'proportion' ),
    w           = $this.attr('width'),
    actual_w    = $this.width();
    
    if ( ! proportion )
    {
        proportion = $this.attr('height') / w;
        $this.data( 'proportion', proportion );
    }
  
    if ( actual_w != w )
    {
        $this.css( 'height', Math.round( actual_w * proportion ) + 'px' );
    }
  });
}
$(window).on('resize load',adjustIframes);
// ===========================end responsive=====================================//


$(window).resize(function(){
var windowwidth = $(window).width();
if(windowwidth > 1200 ){
jQuery(document).ready(function($) {
  var header =  jQuery('.header-main').height();
  jQuery( '.banner__content' ).css( 'padding-top',header);


});
}

});

$(".section_without_margin").parent().addClass("section_without_margin_main");

$(document).ready(function(){
  $(".menu-drawer__navigation-container .icon-close").click(function(){
    $("details.menu-drawer-container").removeClass("menu-opening");
    $("details.menu-drawer-container").removeAttr("open");
  });
});

});</weightsarray.length;>